import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { SampleCollectionTimeApiService } from "modules/ScanningApp/api/sampleCollectionTime.api";

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statusCode: number;
}

export const useSampleCollectionTimeService = (payload?: any) => {
  const queryClient = useQueryClient();

  const SelectAllQuery = useQuery<ApiResponse, Error>({
    queryKey: [
      "sample-collection-time-select-all",
      payload?.studyid,
      payload?.period_number,
      payload?.timepoint_number,
      payload?.searchtext,
      payload?.filterstatus,
    ],
    queryFn: () => SampleCollectionTimeApiService.selectAllData(payload),
    enabled: !!payload?.studyid && !!payload?.period_number && !!payload?.timepoint_number,
  });

  const UpdateMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payloadData: any) => SampleCollectionTimeApiService.updateData(payloadData),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["sample-collection-time-select-all"],
      });
    },
  });

  return { SelectAllQuery, UpdateMutation };
};
